module.exports = __webpack_public_path__ + "static/img/6671_phase_function_Paper_PointsHejduk_Prediction.8034089.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/6671_phase_function_Paper_PointsHejduk_Prediction.png
// module id = pqke
// module chunks = 0